import { GenderNonBinaryIcon } from './GenderNonBinaryIcon';

/**
 * author: Michael Irigoyen
 * id 85F577F7-626B-4D2D-A392-2671C979BEF3
 * name gender-non-binary
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gender-non-binary.svg
 * tags
 */
export const GenderEnbyIcon = GenderNonBinaryIcon;
export default GenderEnbyIcon